import { Injectable, signal, computed } from '@angular/core';
import { TenantListVm } from '../models';

@Injectable({ providedIn: 'root' })
export class TenantContextService {
  private _activeTenantId = signal<string>('');
  private _tenants = signal<TenantListVm[]>([]);

  readonly activeTenantId = this._activeTenantId.asReadonly();
  readonly tenants = this._tenants.asReadonly();
  readonly activeTenant = computed(() => {
    const id = this._activeTenantId();
    return this._tenants().find(t => t.id === id) ?? null;
  });

  setTenants(tenants: TenantListVm[]) {
    this._tenants.set(tenants);
    if (tenants.length > 0 && !this._activeTenantId()) {
      this._activeTenantId.set(tenants[0].id);
    }
  }

  switchTenant(tenantId: string) {
    this._activeTenantId.set(tenantId);
  }
}
